var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSaveLine = function SvgSaveLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.25 15.25v-4.5h7.5v4.5h1.5V6.871L13.129 4.75H4.75v10.5zM4 3.25h9.75l3 3V16a.75.75 0 0 1-.75.75H4a.75.75 0 0 1-.75-.75V4A.75.75 0 0 1 4 3.25m3.75 9v3h4.5v-3z"
  })));
};
export default SvgSaveLine;